import axios from '@/integrations/axios'
import { toQueryParams } from '@/lib/utils'
import type { CarListQuery, CarListResponse, CarResponse } from '@backend/schemas'

export const fetchCars = async (params: Partial<CarListQuery>) => {
  const response = await axios.get<CarListResponse>(`/v1/cars`, { params: toQueryParams(params) })
  const data = response.data
  return data
}

export const fetchCarById = async (id: string) => {
  const response = await axios.get<CarResponse>(`/v1/cars/${id}`)
  const data = response.data
  return data
}
